export default "__VITE_ASSET__B2OagZDx__"